import {
	httpRequest,
	querystringBuilder,
	querystringBuilderByObject,
	getPayload,
} from './api-common.util';

export default class WebapiCommon {
	static sendEmail({ mensagem, laudo, destinatario, assunto }) {
		return httpRequest(`email`, 'POST', {
			mensagem,
			laudo,
			destinatario,
			assunto,
		});
	}
	static getEmail(laudo) {
		return httpRequest(`email/${laudo}`);
	}
	static baseConhecimento(termo, pagina, filtro) {
		return httpRequest('BaseConhecimento', 'POST', {
			termo,
			numeroPagina: pagina,
			filter: filtro,
		});
	}
	static baseConhecimentoPdf(id) {
		return httpRequest(`BaseConhecimento/pdf/${id}`);
	}
	static unidadeAtendimento() {
		return httpRequest(`UnidadeAtendimento`);
	}
	static getTotalExamesVincular(prontuario) {
		return httpRequest(
			`pacientes/${prontuario}/exames?todos=true&count=true`
		).then((json) => json.data);
	}
	static novoAutoTexto(payload) {
		return httpRequest('autotexto/criar-novo', 'POST', {
			...payload,
		}).then((json) => json.data);
	}

	static novoGrupoExame(nome) {
		return httpRequest('GrupoExame', 'POST', {
			nome,
		}).then((json) => json.data);
	}
	static getGrupoExame() {
		return httpRequest('GrupoExame').then((json) => json.data);
	}

	static getExamesFinalizados(prontuario) {
		return httpRequest(`pacientes/${prontuario}/exames?todos=true`).then(
			(json) => json.data
		);
	}

	static getExamesCancelados(prontuario, laudo) {
		return httpRequest(
			`pacientes/${prontuario}/exames/cancelado/${laudo}`
		).then((json) => json.data);
	}

	static getTotalExamesFinalizados(prontuario) {
		return httpRequest(
			`pacientes/${prontuario}/exames?todos=true&count=true`
		).then((json) => json.data);
	}

	static getExamesEmAberto(prontuario, laudo) {
		return httpRequest(
			`pacientes/${prontuario}/exames?laudoid=${laudo}&concluido=false&count=false&desconsiderarexamedolaudo=true`
		).then((json) => json.data);
	}

	static getTotalExamesEmAberto(prontuario, laudo) {
		return httpRequest(
			`pacientes/${prontuario}/exames?laudoid=${laudo}&concluido=false&count=true&desconsiderarexamedolaudo=true`
		).then((json) => json.data);
	}

	static getLaudosAnteriores(prontuario) {
		return httpRequest(`pacientes/${prontuario}/exames?concluido=true`).then(
			(json) => json.data
		);
	}
	static getLaudosAnterioresQuantidade(prontuario) {
		return httpRequest(
			`pacientes/${prontuario}/exames?concluido=true&count=true`
		).then((json) => json.data);
	}
	// Fim Apis prontuários

	// static imprimirEtiquetas(etiquetas) {
	// 	return httpRequest('imprimir/material', 'POST', etiquetas).then(
	// 		json => json.data
	// 	);
	// }
	static entregaResultadoExame(laudo, entregaResultadoExameRequest) {
		return httpRequest(
			`entregaresultadoexame/${laudo}`,
			'PATCH',
			entregaResultadoExameRequest
		);
	}

	static gravarAuditoria(laudo, mensagem) {
		return httpRequest('auditoria', 'POST', {
			laudo,
			mensagem,
		}).then((json) => json.data);
	}

	static getListagemMultiplosExames(laudo) {
		return httpRequest(`laudos/${laudo}/multiexames`).then((json) => json.data);
	}

	static registrarMultiplosExames(laudo, request) {
		return httpRequest(`laudos/${laudo}/multiexames`, 'POST', request).then(
			(json) => json.data
		);
	}

	static obterMultiExames(exameid) {
		return httpRequest(`multiexames/${exameid}`).then((json) => json.data);
	}

	static atualizarExameMultiplosExames(exameId, request) {
		return httpRequest(`multiexames/${exameId}`, 'PATCH', request).then(
			(json) => json.data
		);
	}

	static apagarRegistroExameMultiplosExames(idlaudoexames) {
		return httpRequest(`multiexames/${idlaudoexames}`, 'DELETE');
	}

	static faturarExameComplementar(idlaudoexames) {
		return httpRequest(`multiexames/${idlaudoexames}/faturamento`, 'PATCH');
	}

	static cancelamentoFaturamento(exameId) {
		return httpRequest(
			`multiexames/${exameId}/faturamento/cancelar`,
			'PATCH'
		).then((json) => json.data);
	}

	static getTopografias() {
		return httpRequest('topografias').then((json) => json.data);
	}

	static getDetalhes(laudo) {
		return httpRequest(`laudos/${laudo}`).then((json) => json.data);
	}

	static getFiltros(usuarioId) {
		return httpRequest(`filtro/usuario/${usuarioId}`).then((json) => json.data);
	}

	static getListagem(selecionados, pagina, ordenacao) {
		const _getPayload = getPayload(selecionados);

		let payload = {
			..._getPayload,
			ordenacao,
			// ...selecionados[0],
		};
		return httpRequest(`laudos/${pagina}/10`, 'POST', payload).then(
			(json) => json.data
		);
	}

	static finalizarReabrirMapa(laudo, reabrir, textoJustificativaReabertura) {
		let payload = {};
		if (textoJustificativaReabertura) {
			payload = { textoJustificativaReabertura };
		}
		return httpRequest(
			`laudos/${laudo}/mapa?reabrir=${reabrir}`,
			'PATCH',
			payload
		).then((json) => json.data);
	}

	static registrarNaoConformidade(laudo, nConfRequest) {
		return httpRequest(`laudos/${laudo}/nconformidades`, 'POST', nConfRequest);
	}

	static getColoracoes() {
		return httpRequest(`coloracao`).then((json) => json.data);
	}

	static getAntigenos() {
		return httpRequest(`anticorpos`).then((json) => json.data);
	}

	static getMaterialTotalmenteSubmetido(laudo) {
		return httpRequest(`laudos/${laudo}/MaterialTotalmenteSubmetido`).then(
			(json) => json.data
		);
	}

	static agruparCassetes(ids, complemento, laudo) {
		return httpRequest(`blocos/agrupar`, 'POST', {
			blocos: ids,
			complemento,
			laudo,
		}).then((json) => json.data);
	}

	static getFrascos(laudo) {
		return httpRequest(`laudos/${laudo}/frascos`).then((json) => json.data);
	}

	static getMaterial() {
		return httpRequest('materiais').then((json) => json.data);
	}

	static getTipo(intl) {
		return [
			{
				value: '0',
				label: `${intl.formatMessage({ id: 'dashboards.histology.biopsy' })}`,
			},
			{
				value: '1',
				label: `${intl.formatMessage({
					id: 'dashboards.examDetail.freezing',
				})}`,
			},
			{
				value: '2',
				label: `${intl.formatMessage({ id: 'dashboards.histology.piece' })}`,
			},
			{
				value: '3',
				label: `${intl.formatMessage({ id: 'dashboards.cytology.cytology' })}`,
			},
			{
				value: '4',
				label: `${intl.formatMessage({ id: 'dashboards.histology.autopsy' })}`,
			},
			{
				value: '5',
				label: 'SVO',
			},
			{
				value: '6',
				label: `${intl.formatMessage({ id: 'dashboards.histology.puncture' })}`,
			},
			{
				value: '7',
				label: `${intl.formatMessage({
					id: 'dashboards.examDetails.status.revision',
				})}`,
			},
		];
	}
	static getMedicoTecnico() {
		return httpRequest('medicos');
	}

	static getMedicos() {
		return httpRequest('medicos').then((json) => json.data);
	}

	static getNaoConformidades() {
		return httpRequest('nconformidades').then((json) => json.data);
	}

	static getTotalNaoConformidades(laudo) {
		return httpRequest(`laudos/${laudo}/nconformidades?count=true`).then(
			(json) => json.data
		);
	}

	static getHistoricoNaoConformidades(laudo) {
		return httpRequest(`laudos/${laudo}/nconformidades?count=false`).then(
			(json) => json.data
		);
	}

	static atualizarSnImprimirNConformidadeNoLaudo(
		histid,
		atualizarSnImprimirNConformidadeNoLaudo
	) {
		return httpRequest(`nconformidades/historico/${histid}`, 'PATCH', {
			atualizarSnImprimirNConformidadeNoLaudo:
				atualizarSnImprimirNConformidadeNoLaudo,
		}).then((json) => json);
	}

	static resolverNaoConformidade(id, justificativa) {
		return httpRequest(
			`nconformidades/${id}`,
			'PUT',
			{
				id: id,
				justificativa: justificativa,
			},
			'v2'
		).then((json) => json);
	}

	static registrarFrasco(laudo, frascos) {
		return httpRequest(`laudos/${laudo}/frascos`, 'POST', frascos, 'v2').then(
			(json) => json
		);
	}

	static gerarFrasco(laudo, frascosNovosArray) {
		return httpRequest(
			`laudos/${laudo}/frascos`,
			'POST',
			frascosNovosArray,
			'v3'
		).then((json) => json);
	}

	static vincularLaudoAnterior(
		laudo,
		laudoAnterior,
		justificativa,
		vincula = false
	) {
		return httpRequest(`laudos/${laudo}/vincular`, 'PATCH', {
			laudoAnterior: laudoAnterior,
			justificativa,
			vinculaMaterial: vincula,
		}).then((json) => json);
	}

	static getItensChecklist(exame, paciente) {
		return httpRequest(`exames/${exame}/paciente/${paciente}/checklist`).then(
			(json) => json.data
		);
	}
	static getSelectOptionsChecklist() {
		return httpRequest(`checklist/respostasTipoSelect`);
	}

	static gravarRespostaChecklist(laudo, usuarioId, questionarioId, respostas) {
		return httpRequest(`checklist/historico`, 'POST', {
			laudo,
			usuarioId,
			questionarioId,
			respostas,
		}).then((json) => json.data);
	}

	static getHistoricoRespostaQuestionario(laudo) {
		return httpRequest(`checklist/laudo/${laudo}/checklisthistorico`).then(
			(json) => json.data
		);
	}

	static getRespostasQuestionario(historicoId) {
		return httpRequest(`checklisthistorico/${historicoId}/respostas`).then(
			(json) => json.data
		);
	}

	static getEtiqueta(exame) {
		return httpRequest(`etiqueta?exame=${exame}`).then((json) => json.data);
	}

	static getAutoCompletar() {
		return httpRequest('recebimentomaterial/autocompletar');
	}

	static getListagemAutotexto(exameId) {
		return httpRequest(`exames/${exameId}/textos`).then((json) => json.data);
	}
	static getListagemAutotextoGeral() {
		return httpRequest(`exames/textos`).then((json) => json.data);
	}

	static getAutotexo(id) {
		return httpRequest(`textopadrao/${id}`).then((json) => json.data);
	}

	static getListagemFrascos(laudo) {
		return httpRequest(`frascos/${laudo}/blocos`).then((json) => json.data);
	}

	static inserirMapaLaudo(laudo, blocos) {
		return httpRequest(`laudos/${laudo}/mapa`, 'POST', blocos).then(
			(json) => json.data
		);
	}

	static getLaudoFinal(laudo) {
		return httpRequest(
			`laudos/${laudo}/etapas/final/rtf?base64=true`,
			'GET',
			undefined,
			'v2'
		);
	}

	static getLaudoFinalStr(laudo) {
		return httpRequest(
			`laudos/${laudo}/etapas/final/rtf?base64=false`,
			'GET',
			undefined,
			'v2'
		);
	}

	static getBlocos(laudo) {
		return httpRequest(`laudos/${laudo}/blocos`).then((json) => json.data);
	}

	static getBlocosExameMacroFinalizada(laudo) {
		//Lista blocos de exames com a macroscopia finalizada
		return httpRequest(`blocos/laudo/${laudo}/macro-finalizada`).then(
			(json) => json.data
		);
	}

	static gerarBlocos(laudo, blocos) {
		return httpRequest(`laudos/${laudo}/blocos`, 'PATCH', blocos).then(
			(json) => json.data
		);
	}

	static gravarBlocos(laudo, blocos) {
		return httpRequest(`laudos/${laudo}/blocos`, 'POST', blocos).then(
			(json) => json
		);
	}

	static getDetalhesBlocos(laudo, laudoBloco) {
		return httpRequest(`blocos/${laudo}/bloco/${laudoBloco}`).then(
			(json) => json.data
		);
	}

	static getExames() {
		return httpRequest('exames').then((json) => json.data);
	}

	static atualizarBlocos(laudo, laudobloco, blocos) {
		return httpRequest(
			`blocos/${laudobloco}/laudo/${laudo}`,
			'PATCH',
			blocos
		).then((json) => json.data);
	}

	static cancelarBlocos(laudo, laudobloco, blocos) {
		return httpRequest(
			`blocos/${laudobloco}/cancelamento/laudo/${laudo}`,
			'PATCH',
			blocos
		).then((json) => json.data);
	}

	static getFiltrosFavoritosUsuario(usuarioLogadoId) {
		return httpRequest(
			`filtro/favoritos/filtros/usuario/${usuarioLogadoId}`
		).then((json) => json.data);
	}

	static getFiltroFavorito(filtroId) {
		return httpRequest(`filtro/favoritos/filtro/${filtroId}`).then(
			(json) => json.data
		);
	}

	static getListagemAnexo(laudo) {
		return httpRequest(`laudos/${laudo}/anexos`).then((json) => json.data);
	}

	static downloadAnexo(anexoid) {
		return httpRequest(`anexos/download/${anexoid}`, 'POST');
	}

	static excluirAnexo(anexoid, justificativa, nome, laudo) {
		return httpRequest(
			`anexos/${anexoid}?justificativa=${justificativa}&nome=${nome}&laudo=${laudo}`,
			'DELETE'
		);
	}

	static getListaLaudoHistorico(laudo) {
		return httpRequest(`laudohistorico/${laudo}`).then((json) => json.data);
	}

	static getTextoLaudoHistorico(laudo, laudoHistoricoId) {
		return httpRequest(
			`laudohistorico/${laudo}/texto/${laudoHistoricoId}`
		).then((json) => json.data);
	}

	static obterUsuarios() {
		return httpRequest('segusu').then((json) => json.data);
	}

	static apagarCasseteEReordenar(
		idlaudobloco,
		laudo,
		frasco,
		blocoASerCancelado
	) {
		return httpRequest(
			`laudoBlocos/${idlaudobloco}/laudo/${laudo}/frasco/${frasco}`,
			'PATCH',
			blocoASerCancelado
		).then((json) => json.data);
	}

	static cancelarFrasco(laudo, frasco, justificativa) {
		return httpRequest(
			`laudos/${laudo}/frascos/${frasco}`,
			'PUT',
			{
				justificativa,
			},
			'v2'
		).then((json) => json);
	}

	static obterListagemDocumentosLaudo(laudo) {
		return httpRequest(`laudos/${laudo}/documentoexterno`).then(
			(json) => json.data
		);
	}

	static registrarRecebimentoDocExterno(laudo, request) {
		return httpRequest(
			`laudos/${laudo}/documentoexterno`,
			'POST',
			request
		).then((json) => json.data);
	}

	static atualizarTopografia(
		laudo,
		frasco,
		topografia,
		labelTopografiaAtual,
		labelNovaTopografiaSelecionada
	) {
		return httpRequest(`laudos/${laudo}/frascos/${frasco}`, 'PUT', {
			topografia: topografia,
			topografiaAtual: labelTopografiaAtual,
			topografiaAtualizada: labelNovaTopografiaSelecionada,
		}).then((json) => json);
	}

	static cancelarEntregaResultadoExame(
		laudo,
		id,
		justificativaCancelamentoEntrega
	) {
		return httpRequest(
			`entregaresultadoexame/${laudo}/${id}/cancelar`,
			'PATCH',
			justificativaCancelamentoEntrega
		);
	}
	static obterHistoricoEntrega(laudo) {
		return httpRequest(`entregaresultadoexame/${laudo}`, 'GET').then(
			(json) => json.data
		);
	}

	static checkFaturamento(laudo) {
		return httpRequest(`faturamento/${laudo}/check`).then((json) => json.data);
	}

	static getTotalMensagens(usuarioId) {
		return httpRequest(`mensagem/usuario/${usuarioId}/total`, 'GET').then(
			(json) => json.data
		);
	}

	static getTotalCertificadosPendentes(payload) {
		return httpRequest(`certificacao/pendentes/count`, 'GET').then(
			(json) => json.data
		);
	}
	static enviarCertificadosPendentesSelecionados(payload) {
		return httpRequest(`certificacao`, 'PATCH', payload).then(
			(json) => json.data
		);
	}
	static enviarCertificadosPendentes(payload) {
		return httpRequest(`certificacao/pendentes`, 'PATCH', payload).then(
			(json) => json.data
		);
	}
	static getCertificadosPendentes(payload) {
		const querystring = querystringBuilderByObject(payload);
		return httpRequest(`certificacao/pendentes${querystring}`, 'GET').then(
			(json) => json.data
		);
	}
	static getSessaoDialogo(usuarioId) {
		return httpRequest(`mensagem/usuario/${usuarioId}`, 'GET').then(
			(json) => json.data
		);
	}
	static getSessaoDialogoLaudo(laudo, usuarioId) {
		return httpRequest(`mensagem/laudo/${laudo}/${usuarioId}`, 'GET').then(
			(json) => json.data
		);
	}
	static gravarNovaSessao(laudo, assunto) {
		return httpRequest('mensagem/sessao', 'POST', {
			laudo,
			assunto,
		}).then((json) => json.data);
	}
	static getMensagensSessao(sessaoId) {
		return httpRequest(`mensagem/sessao/${sessaoId}`, 'GET').then(
			(json) => json.data
		);
	}
	static checkMensagemLida(usuarioId, mensagemId) {
		return httpRequest('mensagem/check', 'POST', {
			usuarioId: usuarioId,
			mensagemId: mensagemId,
		}).then((json) => json.data);
	}
	static getUsuarios() {
		return httpRequest('segusu', 'GET').then((json) => json.data);
	}
	static enviarMensagem(sessaoId, remetenteId, destinatarioId, texto) {
		return httpRequest('mensagem', 'POST', {
			sessaoId,
			remetenteId,
			destinatarioId,
			texto,
		}).then((json) => json.data);
	}
	static marcarLaudoUrgente(laudo, checked, justificativa) {
		return httpRequest(`laudos/${laudo}/urgente`, 'POST', {
			urgente: checked ? 'S' : 'N',
			justificativa: justificativa,
		}).then((json) => json.data);
	}
	static marcarLaudoCritico(laudo, checked, justificativa) {
		return httpRequest(`laudos/${laudo}/critico`, 'POST', {
			critico: checked,
			justificativa: justificativa,
		}).then((json) => json.data);
	}
	static editarMedicoResponsavelLaudo(
		laudo,
		medico,
		etapa,
		item,
		laudoTextoId
	) {
		let request = {
			dataEntregaPrevista: '',
			Etapa: etapa,
		};
		if (!item || item === 'medico') {
			request = {
				...request,
				MedicoResponsavel: medico,
			};
		} else {
			request = {
				...request,
				MedicoRevisor: medico,
			};
		}
		if (laudoTextoId) {
			request = {
				...request,
				LaudoTextoId: laudoTextoId,
			};
		}
		return httpRequest(`laudos/${laudo}`, 'PATCH', request);
	}
	static editarDataPrevistaEntregaLaudo(laudo, dataPrevista) {
		return httpRequest(`laudos/${laudo}`, 'PATCH', {
			dataEntregaPrevista: dataPrevista,
		});
	}
	static gravarNumeroExterno(
		laudo,
		numeroExterno,
		qtdBloco,
		qtdLamina,
		frascoId
	) {
		return httpRequest('exameexterno', 'POST', {
			laudo,
			numeroExterno,
			qtdBloco,
			qtdLamina,
			frascoId,
		});
	}
	static excluirExameExterno(laudo, justificativa) {
		return httpRequest(`exameexterno/excluir`, 'POST', {
			laudo,
			justificativa,
		});
	}
	static getLaudosLiberadosParaGrafico(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/laudos/liberados?entregade=${entregaDe}&entregaate=${entregaAte}`
		);
	}
	static getGraficoTotalNaoConformidades(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/naoconformidades?entregade=${entregaDe}&entregaate=${entregaAte}`
		);
	}
	static getTotalNaoConformidadesPorEtapa(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/naoconformidades/etapas?entregade=${entregaDe}&entregaate=${entregaAte}`
		);
	}
	static getTempoMedioEtapas(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/etapas/duracao?entregade=${entregaDe}&entregaate=${entregaAte}`
		);
	}
	static getCancelamentosEtapas(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/etapas/cancelamento?entregade=${entregaDe}&entregaate=${entregaAte}`
		);
	}
	static obterFaturamento(laudo) {
		return httpRequest(`faturamento/${laudo}/etapas`);
	}
	static obterEtapasFaturaveis(exame, laudo) {
		return httpRequest(`exames/${exame}/etapas/faturamento?laudo=${laudo}`);
	}
	static getMedicosEtapa(laudo, etapa) {
		return httpRequest(`medicos/laudo/${laudo}/etapa/${etapa}`).then(
			(json) => json.data
		);
	}
	static faturar(laudo, etapa, request) {
		return httpRequest(
			`faturamento/${laudo}/etapas/${etapa}`,
			'PATCH',
			request
		);
	}

	static desvincularLaudoAnterior(laudo, justificativa, cdPedidoRx) {
		return httpRequest(`laudos/${laudo}/desvincular`, 'POST', {
			justificativa: justificativa,
			cdPedidoRx: cdPedidoRx,
		});
	}

	static vincularLaudoCancelado(laudoVigente, laudoCancelado, check) {
		if (check) {
			return httpRequest(`laudos/vincular/cancelado`, 'POST', {
				laudoVigente,
				laudoCancelado,
				check,
			}).then((json) => json.data);
		} else {
			return httpRequest(`laudos/vincular/cancelado`, 'DELETE', {
				laudoVigente,
				laudoCancelado,
				check,
			}).then((json) => json.data);
		}
	}

	static atualizarTexto(
		laudo,
		texto,
		etapa,
		plainText,
		statusEtapa,
		laudoTextoId,
		medicoExecutante,
		medicoRevisor,
		headerFooter,
		adicionarNaLaudoHistorico = true
	) {
		return httpRequest(`laudos/${laudo}/etapas/${etapa}/rtf`, 'PATCH', {
			texto: texto,
			adicionarItemLaudoHistorico: adicionarNaLaudoHistorico,
			plainText,
			statusEtapa,
			laudoTextoId,
			medicoExecutante,
			medicoRevisor,
			headerFooter,
		})
			.then((json) => {
				return json.data;
			})
			.catch((err) => {
				console.error(
					`[ERRO no retorno da API / PATCH]: laudos/${laudo}/etapas/${etapa}/rtf`,
					err
				);
			});
	}
	static laudar(laudo, laudarEtapaRequest, etapa) {
		return httpRequest(
			`laudos/${laudo}/etapas/${etapa}`,
			'PATCH',
			laudarEtapaRequest
		);
	}
	static getTextoLaudo(laudo, etapa) {
		return httpRequest(
			`laudos/${laudo}/etapas/${etapa}/rtf?base64=true`,
			'GET',
			undefined,
			'v2'
		);
	}
	static getTextoLaudoByID(laudo, etapa, id) {
		return httpRequest(
			`laudos/${laudo}/etapas/${etapa}/rtf?base64=true&laudotexto=${id}`,
			'GET',
			undefined,
			'v2'
		);
	}
	static getListagemLaminas(laudoId, etapa) {
		return httpRequest(`lamina/${laudoId}/${etapa}`).then((json) => json.data);
	}

	static getTextoLamina(laudoId, etapa) {
		return httpRequest(`lamina/${laudoId}/${etapa}/texto`).then(
			(json) => json.data
		);
	}
	static getTextoLaminaImuno(laudoId) {
		return httpRequest(`lamina/${laudoId}/texto-imuno`).then(
			(json) => json.data
		);
	}

	static getLaminasExameMicroFinalizada(laudo) {
		//Lista lâminas de exames com a microscopia finalizada
		return httpRequest(`lamina/laudo/${laudo}/micro-finalizada`).then(
			(json) => json.data
		);
	}

	static getHistInconformidadesLamina(id) {
		return httpRequest(`lamina/${id}/nconformidades`, 'GET').then(
			(json) => json.data
		);
	}
	static getHistInconformidadesBlocos(id) {
		return httpRequest(`cassetes/${id}/nconformidades`, 'GET').then(
			(json) => json.data
		);
	}

	static getCabecalhoRodape(laudo, etapa) {
		return httpRequest(`laudos/${laudo}/${etapa}/preview`);
	}

	static getMorfologias() {
		return httpRequest(`diagnosticos`, 'GET').then((json) => json.data);
	}
	static getMorfologiaPorTopografia(topografia) {
		return httpRequest(`diagnosticos/${topografia}`, 'GET').then(
			(json) => json.data
		);
	}

	static getMorfologiaPorTermo(termoDigitado) {
		return httpRequest(`diagnosticos/filtro/${termoDigitado}`, 'GET').then(
			(json) => json.data
		);
	}

	static getTopografiaPorLaudo(laudo) {
		return httpRequest(`laudos/${laudo}/topografias`, 'GET').then(
			(json) => json.data
		);
	}
	static adicionarMorfologia({
		pacienteId,
		diagnosticoId,
		topografiaId,
		anotacoes,
		medicoId,
		cidPrincipal,
		etapa,
		laudo,
	}) {
		return httpRequest(`laudos/${laudo}/diagnosticos`, 'POST', {
			pacienteId,
			diagnosticoId,
			sinonimoId: 0,
			topografiaId,
			anotacoes,
			medicoId,
			cidPrincipal,
			etapa,
		}).then((json) => json.data);
	}
	static updateCIDPrincipal(laudo, morfologia, topografia, cid) {
		return httpRequest(`laudos/${laudo}/diagnosticos/${morfologia}`, 'PUT', {
			topografiaId: topografia,
			cidPrincipal: cid,
		}).then((json) => json.data);
	}
	static getCIDPorLaudo(laudo) {
		return httpRequest(`laudos/${laudo}/diagnosticos`, 'GET').then(
			(json) => json.data
		);
	}

	static alterarCIDPorLaudo(
		laudo,
		diagnosticoId,
		topografiaId,
		laudoDiagnosticoId
	) {
		return httpRequest(`laudos/${laudo}/alterarcid`, 'PUT', {
			diagnosticoId,
			topografiaId,
			laudoDiagnosticoId,
		}).then((json) => json.data);
	}

	static apagarCIDporLaudo(laudo, diagnosticoId) {
		return httpRequest(`laudos/${laudo}/removercid/${diagnosticoId}`, 'DELETE');
	}
	static getSinonimosPorTopografia(topografia) {
		return httpRequest(`sinonimos/${topografia}`, 'GET').then(
			(json) => json.data
		);
	}

	static cancelamentoRecebimentoMaterial(
		laudo,
		cdPedidoRx,
		justificativa,
		cancelarBlocoAndLaminas
	) {
		return httpRequest(`cancelamento/${laudo}/material`, 'PATCH', {
			cdpedidorx: cdPedidoRx,
			justificativa,
			cancelarBlocoAndLaminas,
		});
	}

	static reabrirRecebimentoMaterial(
		laudo,
		cdPedidoRx,
		justificativa,
		cancelarBlocoAndLaminas
	) {
		return httpRequest(`cancelamento/${laudo}/material`, 'PATCH', {
			cdpedidorx: cdPedidoRx,
			justificativa,
			cancelarBlocoAndLaminas,
			ManterNrExameEtapaMaterial: true
		});
	}

	static getGrupoUsuarios() {
		return httpRequest(`filtro/favoritos/grupo`).then((json) => json.data);
	}
	static getConfiguracaoFaturamento() {
		return httpRequest(`configuracoes/faturamento`).then((json) => json.data);
	}
	static getConfiguracaoLiberacaoLaudo() {
		return httpRequest(`configuracoes/liberacao-laudo`).then(
			(json) => json.data
		);
	}
	static getConfiguracaoMapaMacroscopico() {
		return httpRequest(`configuracoes/mapa`).then((json) => json.data);
	}
	static gravarConfiguracaoMapaMacroscopico(
		configuracoesMapaMacroscopicoRequest
	) {
		return httpRequest(
			'configuracoes/mapa',
			'POST',
			configuracoesMapaMacroscopicoRequest
		);
	}
	static getConfiguracaoEngrega(laudo) {
		return httpRequest(`configuracoes/entrega/${laudo}`).then(
			(json) => json.data
		);
	}
	static getGraficoProdutividadeMaterial(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/material/produtividade?de=${entregaDe}&ate=${entregaAte}`
		);
	}
	static getGraficoProdutividadeMapa(entregaDe, entregaAte) {
		return httpRequest(
			`graficos/mapa/produtividade?de=${entregaDe}&ate=${entregaAte}`
		);
	}

	static obterSetores() {
		return httpRequest('setores').then((json) => json.data);
	}

	static obterProcessos() {
		return httpRequest('processos').then((json) => json.data);
	}
	static registraRecolhimentoMultiplo(recolhimentoMultiploRequest) {
		return httpRequest(
			`rastreabilidade/multi`,
			'POST',
			recolhimentoMultiploRequest
		).then((json) => json.data);
	}
	static obterListagemRastreabilidade(laudo) {
		return httpRequest(
			`laudos/${laudo}/rastreabilidade?localizacao=true&auditoria=true&historico=true`
		).then((json) => json.data);
	}
	static obterLocalProcedencia() {
		return httpRequest('localprocedencia').then((json) => json.data);
	}
	static imprimirLaudo(laudo, etapas, impressora) {
		return httpRequest(`imprimir/laudo/${laudo}/etapa`, 'POST', {
			impressora,
			etapas,
			retornarPdf: true,
		}).then((json) => json.data);
	}
	static imprimirProtocolo(body) {
		return httpRequest('imprimir/protocolo-entrega', 'POST', body).then(
			(json) => json.data
		);
	}
	static getImpressoras() {
		return httpRequest(`imprimir`).then((json) => json.data);
	}
	static imprimirTermoAnuencia(
		laudo,
		itensCheckboxAnuenciaSelecionados,
		consolidado
	) {
		return httpRequest(`imprimir/anuencia/${laudo}`, 'POST', {
			impressora: '',
			restricoes: itensCheckboxAnuenciaSelecionados,
			consolidado: consolidado,
		}).then((json) => json.data);
	}

	static getLaminas(laudo) {
		return httpRequest(`lamina/laudo/${laudo}`).then((json) => json.data);
	}
	static getLaudoBlocosControleReceptaculo(
		dataRealizadoDe,
		dataRealizadoAte,
		laudo,
		exibirCancelados
	) {
		return httpRequest('relatorio/receptaculos', 'POST', {
			dataRealizadoDe: dataRealizadoDe,
			dataRealizadoAte: dataRealizadoAte,
			impressora: '',
			laudo,
			exibirCancelados: exibirCancelados ? exibirCancelados : false,
		}).then((json) => json);
	}
	static getLaudoBlocosControleImuno(dataRealizadoDe, dataRealizadoAte) {
		return httpRequest('relatorio/imuno', 'POST', {
			dataRealizadoDe: dataRealizadoDe,
			dataRealizadoAte: dataRealizadoAte,
			impressora: '',
		}).then((json) => json);
	}
	static getInformesClinicos(laudo) {
		return httpRequest(`laudos/${laudo}/informes-clinicos`);
	}
	static updateFiltroFavoritoDefault(usuarioid, idfiltrousuario) {
		return httpRequest(
			`filtro/usuario/${usuarioid}/favorito/${idfiltrousuario}`,
			'PATCH'
		);
	}
	static deleteFiltroFavoritoDefault(idfiltrousuario) {
		return httpRequest(`filtro/favorito/${idfiltrousuario}`, 'DELETE');
	}
	static obterStatusEtapasLaudo(laudo) {
		return httpRequest(`laudos/${laudo}/etapas`).then(
			(json) => json.data
		);;
	}
	static cadastrarTopografia(topografica, siglaSexoAplicavel) {
		return httpRequest('topografias', 'POST', {
			topografica: topografica,
			siglaSexoAplicavel: siglaSexoAplicavel,
		}).then((json) => json);
	}

	static getRetornaRestricoesTermoAnuencia() {
		return httpRequest('imprimir/anuencia/restricoes').then(
			(json) => json.data
		);
	}
	static getUsuarioTecnicoDaHistologia() {
		return httpRequest('segusu/histologia').then((json) => json.data);
	}
	static getLaminasCitologia(
		tecnico,
		dataInicial,
		dataFinal,
		numeroDoExame,
		laudoPesquisa,
		numeroDoPedido,
		sortAsc
	) {
		return httpRequest(
			`citologia?tecnicoId=${tecnico}&dataInicio=${dataInicial}&dataFim=${dataFinal}&nrExame=${numeroDoExame}&laudo=${laudoPesquisa}&numeroPedido=${numeroDoPedido}&sortAsc=${sortAsc}`
		).then((json) => json.data);
	}
	static atualizarStatusDaLamina(laminaID, status, cdRequisicaoImuno = 0) {
		return httpRequest(
			`lamina/${laminaID}/update/status/${status}`,
			'PATCH',
			cdRequisicaoImuno
		).then((json) => json.data);
	}
	static getHistInconformidadesLaudoLamina(coluna, id) {
		return httpRequest(`nconformidades/historico/lamina/${coluna}/${id}`).then(
			(json) => json.data
		);
	}
	static adicionarHistInconformidades(adicionarNConformidadeRequest) {
		return httpRequest(
			'nconformidades/historico',
			'POST',
			adicionarNConformidadeRequest
		).then((json) => json.data);
	}
	static listarComplemento(etapa) {
		return httpRequest(`complementoetapas?etapa=${etapa}`).then(
			(json) => json.data
		);
	}
	static cadastrarComplemento(etapa, complemento) {
		return httpRequest('complementoetapas', 'POST', {
			etapa,
			complemento,
		});
	}
	static cadastrarMateriais(material) {
		return httpRequest('materiais', 'POST', {
			codMaterial: 0,
			nomeMaterial: material,
		}).then((json) => json);
	}
	static getHistoricoNConf(laudo) {
		return httpRequest(`nconformidades/historico/${laudo}`).then(
			(json) => json.data
		);
	}
	static getAutotexto(exame, texto) {
		return httpRequest(`autotexto/${exame}/${texto}`).then((json) => json.data);
	}
	static imprimirEtiquetaAreaTecnica(laminas, modelo = 'areatecnica') {
		return httpRequest(`imprimir/${modelo}`, 'POST', laminas).then(
			(json) => json.data
		);
	}
	static getCitotecnicos() {
		return httpRequest('segusu/citotecnicos', 'GET').then((json) => json.data);
	}
	static laudoExiteEMaterialFoiFinalizado(nrExame) {
		return httpRequest(
			`laudos/nr-exame/${nrExame}/valido-para-macroscopia`
		).then((json) => json.data);
	}
	static getObservacaoLaudo(laudo) {
		return httpRequest(`observacoeslaudo/obter/${laudo}`).then(
			(json) => json.data
		);
	}
	static atualizarObservacoesLaudo(laudo, texto) {
		return httpRequest('observacoeslaudo/inserir', 'POST', {
			laudo: laudo,
			texto: texto,
		});
	}
	static dadosTelaRequisicaoAnticorpos(laudo) {
		return httpRequest(`microscopia/${laudo}/anticorpos`);
	}
	static getAnticorpos() {
		return httpRequest('anticorpos');
	}
	static criarLamina(data) {
		return httpRequest(`lamina/novo`, 'POST', data).then((json) => json);
	}
	static getLaminasImuno(laudo) {
		return httpRequest(`lamina/imuno/${laudo}`).then((json) => json.data);
	}
	static getLaminasCongelacao(laudo) {
		return httpRequest(`lamina/congelacao/${laudo}`).then((json) => json.data);
	}
	static obterRequisicaoImunoCardLaminas(
		tecnico,
		dataInicial,
		dataFinal,
		numeroDoExame,
		laudoPesquisa,
		numeroDoPedido,
		sortAsc
	) {
		return httpRequest(
			`lamina/imuno?tecnicoId=${tecnico}&dataInicio=${dataInicial}&dataFim=${dataFinal}&nrExame=${numeroDoExame}&numeroPedido=${numeroDoPedido}&laudo=${laudoPesquisa}&sortAsc=${sortAsc}`
		).then((json) => json.data);
	}

	static getTiposExame() {
		return httpRequest('tiposexame').then((json) => json.data);
	}

	static obterDadosGeraisHospital() {
		return httpRequest('configuracoes/dados-do-hospital').then(
			(json) => json.data
		);
	}

	static getConfiguracoesGerais() {
		return httpRequest('configuracoes/gerais').then(
			(json) => json.data
		);
	}

	static obterCabecalhoERodape(laudo) {
		return httpRequest(`laudos/${laudo}/cabecalho-rodape`).then(
			(json) => json.data
		);
	}

	static cancelarEtapasPosteriores(laudo, etapa, cdPedidoRx, justificativa) {
		return httpRequest(
			`cancelamento/${laudo}/etapas/${etapa}/cancelar-etapas-posteriores`,
			'PATCH',
			{
				cdPedidoRX: cdPedidoRx,
				justificativa: justificativa,
				CancelarBlocoAndLaminas: false,
			}
		);
	}

	static getLaudoBlocosControleLaminasCitologia(
		dataRealizadoDe,
		dataRealizadoAte
	) {
		return httpRequest('relatorio/LaminasCitologia', 'POST', {
			dataRealizadoDe: dataRealizadoDe,
			dataRealizadoAte: dataRealizadoAte,
			impressora: '',
		}).then((json) => json);
	}

	static getLaudoBlocosControleLaminasHistologia(
		dataRealizadoDe,
		dataRealizadoAte
	) {
		return httpRequest('relatorio/LaminasHistologia', 'POST', {
			dataRealizadoDe: dataRealizadoDe,
			dataRealizadoAte: dataRealizadoAte,
			impressora: '',
		}).then((json) => json);
	}

	static getCompetenciasFaturamento(
		cdMultiEmpresa
	) {
		return httpRequest('siscolo/competencia-faturamento/' + cdMultiEmpresa,
		).then((json) => json);
	}

	static salvarInformacoesSiscolo(body
	) {
		return httpRequest('siscolo', 'POST', body)
		.then((json) => json);
	}

	static getInformacoesSiscolo(laudo
		) {
			return httpRequest('siscolo/' + laudo, 'GET')
			.then((json) => json);
		}

	static getUnidadesSiscolo() {
			return httpRequest('siscolo/unidades', 'GET')
			.then((json) => json);
		}

	static GetSiscoloVariaveis(body
		) {
			return httpRequest('siscolo/variaveis', 'PATCH', body)
			.then((json) => json);
		}

	static liberarLaudosEmLote(listaDeLaudoId, usuarioLogado) {
		return httpRequest(`laudos/liberacao-total`, 'POST',
		  {
			usuarioLogado: usuarioLogado,
			Laudos: listaDeLaudoId
		  }
		).then((json) => json.data);
	  }

	  static getLaudoPorNrExame(nrExame) {
		return httpRequest(
			`laudos/1/10/`,'POST', {numeroExame: nrExame}
		).then((json) => json.data.listagem);
	  }

	  static verificarSeExistemImagensRadiologica(acnumber, prontuario) {
		return httpRequest(
			`vivaceconnect/existem-imagens`,'POST', {acNumber: acnumber, prontuario : prontuario}
		).then((json) => json.data);
	  }

	  static obterUrlVivaceConnectAutenticada(acnumber, prontuario) {
		return httpRequest(
			`vivaceconnect/url-vivace-connect`,'POST', {acNumber: acnumber, prontuario : prontuario}
		).then((json) => json.data);
	  }

	  static obterDadoslaudoAgrupado(laudo) {
		return httpRequest(
			`laudos/laudoagrupado/${laudo}`,'GET'
		).then((json) => json.data);
	  }

	  static obterDadoslaudoAgrupadoPedido(laudo, pedido) {
		return httpRequest(
			`laudos/laudoagrupado/pedidos/${laudo}/${pedido}`,'GET'
		).then((json) => json.data);
	  }

	  static AgruparLaudos(body) {
		return httpRequest(
			`laudos/laudoagrupado/agrupar`,'POST' , body
		).then((json) => json.data);
	  }
}



// WEBPACK FOOTER //
// ./src/app/common/util/webapi.common.js